import {format} from 'date-fns';
import {bg} from 'date-fns/locale';

const DateTimeLong = ({
    date,
}) => {
    if (date === undefined) {
        return '';
    }

    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    return format(date, 'dd MMMM yyyy HH:mm:ss', {
        locale: bg,
    });
};

export default DateTimeLong;
